import { ToastOptions, toast as baseToast } from "react-toastify";

/**
 * App-wide toast behaviour: successes and info auto-dismiss, errors stay on
 * screen until the user dismisses them (during a live meeting a vanished
 * error is a missed error). Import `toast` from here, not react-toastify.
 */
export const toast = {
  success: (content: string, options?: ToastOptions) => baseToast.success(content, options),
  info: (content: string, options?: ToastOptions) => baseToast.info(content, options),
  error: (content: string, options?: ToastOptions) => baseToast.error(content, { autoClose: false, ...options }),
  dismiss: baseToast.dismiss,
};
